import { ReactNode } from 'react';
import styled from 'styled-components';

import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import {
  LabelM,
  Text16,
  Text18,
  Title3,
} from '@sorare/core/src/atoms/typography';

import { DecimalScore } from '@sorare/us-sports/src/components/scores/DecimalScore';

const Wrapper = styled.div`
  border-radius: var(--unit);
  background-color: var(--c-neutral-100);
`;

const StatsTableHeader = styled(SBHorizontal).attrs({ gap: 0 })`
  padding: var(--double-unit) var(--triple-unit);
`;

const StatsTableRow = styled(SBHorizontal).attrs({ gap: 0 })`
  padding: var(--unit) var(--triple-unit);
`;

type StatRow = {
  stat: string;
  label: ReactNode | string;
  score: ReactNode | number;
};
type Props = {
  headerTitle: string;
  headerScore: number;
  rows: StatRow[];
};

const StatsTable = (props: Props) => {
  const { headerTitle, headerScore, rows } = props;
  return (
    <Wrapper>
      <StatsTableHeader>
        <Text16 bold>{headerTitle}</Text16>
        <Title3>
          <DecimalScore value={headerScore} />
        </Title3>
      </StatsTableHeader>
      {rows.map(({ stat, label, score }) => (
        <StatsTableRow key={stat}>
          <LabelM bold color="var(--c-neutral-600)">
            {label}
          </LabelM>
          <Text18 bold>{score}</Text18>
        </StatsTableRow>
      ))}
    </Wrapper>
  );
};

export default StatsTable;
